import asBentoPage from 'common/bento/hoc/asBentoPage';
import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';
import ApplicationProblemImage from 'features/Onboarding/components/ApplicationProblemImage';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';

import locales from './locales';

interface CompanyHasSanctionsProps {
  isMandatee: boolean;
}

const CompanyHasSanctions = asBentoPage<CompanyHasSanctionsProps>(
  ({ isMandatee, Layout, onPrev }) => {
    return (
      <Layout nav={<OBNavigation onPrev={onPrev} />}>
        <ApplicationProblemImage />

        <Heading marginBottom="space-16" size="lg">
          {isMandatee ? locales.title.mandatee : locales.title.nonMandatee}
        </Heading>

        <Text variant="primary">
          {isMandatee
            ? locales.description.mandatee
            : locales.description.nonMandatee}
        </Text>
      </Layout>
    );
  },
);

export default CompanyHasSanctions;
